import http from "./constants/http";
import resources from "./constants/resources";

// 공통 - 택배 배송 조회
export const postCommonDelivery = async (body) => {
  const res = http(resources.DELIVERY).post(body);

  if (res.status === 200) {
    return res?.data;
  } else {
    return res;
  }
};

// 공통 - 주문 영수증 보기
export const postCommonReceipt = async (body) => {
  const res = http(resources.RECEIPT).post(body);

  if (res.status === 200) {
    return res?.data;
  } else {
    return res;
  }
};

// 공통 - 채널 제휴문의
export const postCommonBoard = async (body) => {
  const res = http(resources.COMMON_BOARD).post(body);

  if (res.status === 200) {
    return res?.data;
  } else {
    return res;
  }
};

// 공통 - 파일
export const postCommonFiles = async (body) => {
  const res = http(resources.COMMON_FILES).post(body);

  if (res.status === 200) {
    return res.data;
  } else {
    return res;
  }
};
